import React from 'react';
import bindAll from 'lodash.bindall';
import styles from'./uploadToCompetition.css';
import competitionSvg from './competition.svg';
import Fileossupload from '../../containers/oss-upload-file-competition.jsx';
class AixiongReload extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleReload'
        ]);
    }
    handleReload(saveworksCallback){
        // window.location.reload(true);
        return () => {
            saveworksCallback()
        }
    }
    render () {
        return (
            <div className={styles.dropdown} style={{position: 'absolute', right: '50px'}}>
                <div>
                    <div style={{display:'flex', alignItems:'center'}}>
                        <Fileossupload>{(className, saveworksCallback) => (
                            <div className={styles.dropbtn} onClick={this.handleReload(saveworksCallback)}>
                                <img height="40px" src={competitionSvg}/>
                            </div>
                        )}</Fileossupload>
                    </div>
                </div>
            </div>
        );
    }
};

export default AixiongReload;
